import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {IndividualPlanAiGenerated} from '../../../../../../../backend/responses/individual-plan-ai-generated';
import {AiTalk} from '../../../../../../../components/ai-talk/ai-talk';
import {Modal} from '../../../../../../../components/modal/modal';
import {translations} from '../../../../../../../i18n/translations';
import {IndividualPlanDiagnosticsView} from './individual-plan-diagnostics-view';

/**
 * Read-only preview of an individual plan proposal generated by the AI. Everything coming from the
 * AI is rendered as plain text.
 */
export const AiProposalPreview = ({
  proposal,
  isApproving,
  onApprove,
  onDiscard,
}: {
  proposal: IndividualPlanAiGenerated;
  isApproving: boolean;
  onApprove: () => void;
  onDiscard: () => void;
}) => {
  const {t} = useTranslation();
  const labels = translations.seniors.edit.senior_dcm.individual_plan;

  return (
    <Modal
      open
      onClose={onDiscard}
      maxWidth="md"
      fullWidth
      preventCloseClick
      title={t(labels.ai_proposal.title)}
      actions={[
        {
          label: t(labels.ai_proposal.discard),
          type: 'destructive',
          onClick: onDiscard,
          disabled: isApproving,
        },
        {
          label: t(labels.ai_proposal.approve),
          type: 'nondestructive',
          onClick: onApprove,
          loading: isApproving,
        },
      ]}
    >
      <Stack gap="16px">
        <Typography sx={{fontSize: '14px', opacity: 0.7}}>
          {t(labels.ai_proposal.subtitle)}
        </Typography>
        {proposal.explanation && <AiTalk content={proposal.explanation} />}
        <IndividualPlanDiagnosticsView diagnostics={proposal.individualPlan.diagnostics} />
      </Stack>
    </Modal>
  );
};
